/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "32C77C27-9463-4FF0-8CBB-510496C82C19",
  "sitecoreApiHost": "https://zenith-prod-101-cm.azurewebsites.net",
  "jssAppName": "zenith site",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/zenith-site",
  "graphQLEndpoint": "https://zenith-prod-101-cm.azurewebsites.net/api/zenith-site?sc_apikey=32C77C27-9463-4FF0-8CBB-510496C82C19"
};